import { useQuery } from '@tanstack/react-query';

import { fetchNlqSnapshotInfo, formatSnapshotDate } from './nlq-api';

/**
 * Snapshot-freshness hook for the dock line (SCRUM-83): "Based on bank data as
 * of Apr 22, 2026". Cached per session — the snapshot is rebuilt only when new
 * data lands (an ingestion batch, a seed run, or a lazy heal), NOT on a nightly
 * cadence (SCRUM-897), so it changes rarely and a stale-while-revalidate read is
 * fine here (unlike ANSWERS, which are never cached — see nlq-store).
 *
 * Returns null while loading or when the API is unreachable — the dock then
 * renders the line without a date rather than blocking the page.
 */
const SNAPSHOT_INFO_KEY = ['nlq-snapshot-info'] as const;

export function useNlqSnapshotDate(): string | null {
  const { data } = useQuery({
    queryKey: SNAPSHOT_INFO_KEY,
    queryFn: fetchNlqSnapshotInfo,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return formatSnapshotDate(data?.generatedAt);
}
